import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AiChatStateService {
  public readonly activeConversationId = signal<string | null>(null);

  public setActiveConversation(id: string): void {
    this.activeConversationId.set(id);
  }

  public newConversation(): void {
    this.activeConversationId.set(null);
  }
}
